
import { Modal } from '../modal/Modal';
import { StyledPromptTipsModal } from './prompts-tips-modal-style';
import { Spacer } from '../Spacer';
import { useTranslation } from 'react-i18next';

interface IPromptTipsModalProps {
  show: boolean,
  handleClose: () => void
}

export const PromptTipsModal = ({ show, handleClose }: IPromptTipsModalProps) => {
  const { t } = useTranslation();
  
  return (
    <Modal show={show} onClose={handleClose}>
      <StyledPromptTipsModal>
        <p>{t('prompt_tips_title')}</p>
        <Spacer />
        <h2>{t('prompt_tips_do')}</h2>
        <p>✅ {t('prompt_tips_do_write_english')}</p>
        <p>✅ {t('prompt_tips_do_describe_subject')} <br /> <b><i>{t('prompt_tips_do_example')}</i></b></p>
        <p>✅ {t('prompt_tips_do_try_multiple')}</p>

        <Spacer />
        <h2>{t('prompt_tips_dont')}</h2>
        <p>☹️ {t('prompt_tips_dont_specify_style')} <br /> <b><i style={{ textDecoration: 'line-through' }}>{t('prompt_tips_dont_style_example')}</i></b></p>
        <p>☹️ {t('prompt_tips_dont_be_vague')} <br /> <b><i style={{ textDecoration: 'line-through' }}>{t('prompt_tips_dont_vague_example')}</i></b></p>

      </StyledPromptTipsModal>
    </Modal>
  );
};